import { I07CALCPUISSRAD_State } from '@batical/types/src'

const I07CALCPUISSRAD: I07CALCPUISSRAD_State = {
  bati_version: 1,
  name: '',
  saveDate: 0,
  deleted: 0,
  in_acierFonteIndex: 0,
  in_profondeurRadiateur: 0.0,
  in_nombreElement: 0,
  typeRadiateur_uuid: 'EDA1A864-4488-4053-8D28-8F1B03610DF2',
  in_hauteurRadiateur: 0.0,
  in_longeurRadiateur: 0.0,
  regimeDimensionnemnt_uuid: 'D5C16E82-B10F-433A-98ED-E2E394D19A42',
  in_tempConsInt: 0.0,
  res_puissanceNominale: 0.0,
  mode: 'none',
  calcul_code: 'I07CALCPUISSRAD'
}

export default I07CALCPUISSRAD
